import { cerrarSesionCaducada } from './sesionCaducada';

export const dispatchGeneralErrorEvent = (messageError = '', url = '') => {
  const event = new CustomEvent('generalerror', { detail: { messageError, url } });
  document.dispatchEvent(event);
};

const generalCatchError = (error) => {
  const messageError = error.response?.data?.displayMessage || error.response?.data?.message || '';
  const url = error.config?.url || error.request?.responseURL || '';

  // 401 del back = token caducado o inválido: se vuelve al login en vez de
  // dejar al usuario con un toast de error en cada recarga de datos. El propio
  // login (`auth`) devuelve 401 si Google rechaza la cuenta: ahí no se actúa.
  if (error.response?.status === 401 && !/(^|\/)auth$/.test(error.config?.url || '')) {
    cerrarSesionCaducada();
    throw error;
  }

  dispatchGeneralErrorEvent(messageError, url);

  throw error;
};

export default generalCatchError;
